import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const CONTACT_NUMBER_REGEX = '^\\+?[0-9\\s]*$';

export function differentContactNumberValidator(primaryNumber: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value ? control.value.replace(/\s/g, '') : '';
    const primary = primaryNumber ? primaryNumber.replace(/\s/g, '') : '';
    return value && primary && value === primary ? { sameContactNumber: true } : null;
  };
}
